import axios from "axios";
import config from "../config";

// API Key BPS
const BPS_API_KEY = "2a5fc573c8b3c000270a925dd7d8f334";
const BPS_BASE_URL = "https://webapi.bps.go.id/v1/api";

// Ambil daftar organisasi/domain BPS
export const getBpsOrganizations = async () => {
    const res = await axios.get(
        `${BPS_BASE_URL}/domain/type/kab/prov/kabprov/key/${BPS_API_KEY}/`
    );

    // Data ada di res.data.data[1]
    return res.data?.data?.[1] || [];
};

// Ambil jumlah dataset/statictable untuk Kab. Sampang (kode domain = 3527)
export const getBpsDatasetCount = async () => {
    const res = await axios.get(
        `${BPS_BASE_URL}/list/model/statictable/lang/ind/domain/3527/key/${BPS_API_KEY}/page/1`
    );
    const total = res.data?.data?.[0]?.total || 0;

    // Jumlah total ada di res.data.data[0].total
    return total;
};

// Get datasets by pagination
export const getBpsDatasets = async (page = 1, rows = 12) => {
    try {
        const url = `${BPS_BASE_URL}/list/model/statictable/lang/ind/domain/3527/key/${BPS_API_KEY}/page/${page}`;
        const res = await axios.get(url);
        const data = res.data?.data;

        if (!data) return { total: 0, datasets: [] };

        return {
            total: data[0]?.records || 0,
            datasets: (data[1] || []).map(item => ({
                name: item.table_id || "bps",
                title: item.title || "bps",
                author: "BPS Kabupaten Sampang",
                metadata_modified: item.updt_date || new Date().toISOString(),
                subject: item.subj || "",
                excel_url: item.excel || "",
                source: "BPS",
                raw_data: item
            }))
        };
    } catch (error) {
        console.error("Error BPS getBpsDatasets:", error);
        return { total: 0, datasets: [] };
    }
};